import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "GoKarting is better than both sex _and_ bacon",
  "description": "",
  "published": "2013-12-18T00:00:00.000Z",
  "redirect_from": ["/blog/gokarting-is-better-than-both-sex-_and_-bacon/swizec/6459"],
  "categories": "Auto racing, Kart racing, Karting, Motorsport, Recreation and Sports, Sports, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last time I sat in a gokart was much too long ago. About ten years ago I think and it almost doesn't count anyway. Electric indoor karting for ten minutes, bleh.`}</p>
    <p>{`Last time I drove a `}<em parentName="p">{`real`}</em>{` gokart was at some auto show or another when I was ten. Not sure if they still have those, but it used to be common in Slovenia for gokart racing teams to put up a small race track in the parking lot of a big auto show and let people race.`}</p>
    <p>{`Yesterday I got to go again.`}</p>
    <p>{`So. Much. Fun.`}</p>
    <p>{`Screw bacon and sex, give me a small petrol monster and a track and I'm in heaven. Everything else pales in comparison. I can't even explain it.`}</p>
    <p>{`It's just so ... exciting. Exciting is too weak a word. Invigorating?`}</p>
    <p>{`Well let's be honest, it's just adrenaline and your brain desperately fighting to keep you alive through the madness. If you've ever had a 15 minute adrenaline high, you know what I mean. Sure, there's many ways to get an adrenaline high, but motor sports have the best sustainedness.`}</p>
    <p>{`Everything else is just short bursts.`}</p>
    <p>{`You can race down a hill on a longboard. But after a minute, you have to spend a while walking back up or waiting for the shuttle.`}</p>
    <p>{`You can surf a gnarly wave. But after a few seconds, it's back to fighting for your life on the edge of drowning and trying to find the lineup again.`}</p>
    <p>{`You can walk up to a cute girl and say `}<em parentName="p">{`"Hi"`}</em>{`. But all the adrenaline is in the walk up, which lasts all of ten seconds.`}</p>
    <p>{`You can hop on a bike and race down a narrow woodland path. But the longer the hill lasts, the longer it will take you to get back up.`}</p>
    <p>{`You can jump off a plane. But from what I hear that doesn't last very long either.`}</p>
    <p>{`Motor sports ... that just goes and goes and goes. As long as there's something in your fuel tank, you can keep going. Every turn a bit more on the edge. Every overpass a bit more aggressive. Every straight you accelerate sooner and brake later.`}</p>
    <p>{`That feeling when you're neck-and-neck. Wall closing in from one end, gokart closing you in from the other. And you don't let up. It'll work out. It `}<em parentName="p">{`has`}</em>{` to work out, or you'll be in a world of hurt.`}</p>
    <p>{`You scrape the wall and the other guy, but you get through. Bam! Next corner.`}</p>
    <p>{`Luckily, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Kart_racing",
        "title": "Kart racing"
      }}>{`gokarts`}</a>{` are super safe. At least the kind of gokarts they let normal humans drive. You'll be fine even if you let go of any sense of self-preservation you had left.`}</p>
    <p>{`Probably.`}</p>
    <p>{`Unless somebody ignores a yellow flag and smashes into your back full throttle with such force their glasses fly out of the helmet. Yeah that happened, I have no idea how ...`}</p>
    <p>{`... but I can't wait to do this again. If I wasn't a programmer, I'd definitely be a race car driver.`}</p>
    <p>{`Mostly I just want another go so I can wipe that grin off the guy who won. I came 2nd and it `}<em parentName="p">{`bothers`}</em>{` me.`}</p>
    <p><em parentName="p">{`*`}{`glare`}{`*`}</em></p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ca188068-6110-4ca3-abca-9ae9834888f1",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      